<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="font-weight-regular">อัพโหลด Payslip</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-file-input
          v-model="selectFiles"
          multiple
          label="File input"
          accept=".pdf"
          outlined
          dense
          @change="handleSelectFiles"
        ></v-file-input>
        <div>
          <v-btn
            color="primary"
            @click="handleUpload"
            :disabled="files.length === 0"
            :loading="loading"
            >อัพโหลดไฟล์
          </v-btn>
        </div>
      </v-card-text>
      <v-card-text v-if="files.length > 0">
        <v-simple-table fixed-header height="420px">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in files" :key="item.name">
                <td>{{ item.name }}</td>
                <td style="width: 20%">
                  <span v-if="item.status === 'idle'">รอดำเนินการ</span>
                  <span
                    v-else-if="item.status === 'process'"
                    class="primary--text"
                  >
                    <v-progress-circular
                      :width="2"
                      :size="24"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </span>
                  <span
                    v-else-if="item.status === 'success'"
                    class="success--text"
                    >สำเร็จ</span
                  >
                  <span v-else-if="item.status === 'error'" class="error--text">
                    <v-btn color="error" text @click="handleError(item.error)">
                      ไม่สำเร็จ
                    </v-btn>
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogMessageError" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Error </v-card-title>

        <v-card-text class="mt-5 error--text text-capitalize">
          {{ messageError }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogMessageError = false">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      dialogMessageError: false,
      messageError: '',
      loading: false,
      selectFiles: [],
      files: [],
    }
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'อัพโหลด Payslip',
        disabled: true,
      },
    ])
  },
  methods: {
    ...mapActions({
      uploadPayslip: 'upload/uploadPayslip',
    }),
    handleError(error) {
      this.dialogMessageError = true
      this.messageError = error
    },
    handleSelectFiles() {
      this.files = []
      this.selectFiles.forEach((file, index) => {
        this.files.push({
          id: index + 1,
          name: file.name,
          status: 'idle',
          error: null,
        })
      })
    },
    async handleUpload() {
      this.loading = true

      const { company_uuid } = this.$store.state.authentication.company

      for (const selectFile of this.selectFiles) {
        let formData = new FormData()
        formData.append('file', selectFile)

        const payload = {
          company_uuid,
          formData,
        }

        try {
          this.files = this.files.map((file) => {
            if (file.name === selectFile.name) {
              return { ...file, status: 'process' }
            }
            return file
          })

          await this.uploadPayslip(payload)

          this.files = this.files.map((file) => {
            if (file.name === selectFile.name) {
              return { ...file, status: 'success' }
            }
            return file
          })
        } catch (error) {
          if (error.response) {
            this.files = this.files.map((file) => {
              if (file.name === selectFile.name) {
                return {
                  ...file,
                  status: 'error',
                  error:
                    error.response.data?.message || 'Something went wrong.',
                }
              }
              return file
            })
          }
        }
      }

      this.loading = false
    },
  },
}
</script>
